/** Dashboard Constants bean class */
export class DashboardConstants {
	/**
	 * User appointment status
	 */
	public static readonly USER_STATUS = {
		NEED_APPT: 'NoAppt',
		HAVE_APPT: 'Pending',
		COMPLETED_APPT: 'Completed',
	};

	public static readonly STATES = {
		/**
		 * Appointment
		 */
		ELIGIBLE_FOR_PE: 0,
		NO_SCHEDULED_PE: 1,
		UPCOMING_PE: 2,
		COMPLETED_PE: 3,

		/**
		 * Health Reports
		 */
		WAITING_FOR_PE_REPORTS: 4,
		REPORTS_IN: 5,

		/**
		 * Coaching
		 */
		NO_MENTOR_SCHEDULED: 6,
		UPCOMING_MENTOR_APPT: 7,
		COMPLETED_MENTOR_APPT: 8,

		/**
		 * Biometric Reports
		 */
		BIOMETRIC_REPORTS_IN: 9,
		WAITING_FOR_BIOMETRIC_REPORTS: 10,
	};

	/**
	 * User news feed template
	 */
	public static readonly News_Feed_Template = {
		$schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
		type: 'AdaptiveCard',
		version: '1.0',
		id: 'schedule-exam',
		body: [
			{
				type: 'ColumnSet',
				separator: true,
				columns: [
					{
						type: 'Column',
						width: '1',
						id: 'cardDate',
						items: [
							{
								type: 'TextBlock',
								text: '{{articleDate}}',
								wrap: true,
								color: 'good',
							},
						],
					},
					{
						type: 'Column',
						width: 'auto',
						items: [
							{
								type: 'TextBlock',
								text: "<i class='fa fa-bookmark'></i>",
								wrap: true,
								horizontalAlignment: 'right',
								color: 'attention',
							},
						],
					},
					{
						type: 'Column',
						width: 'auto',
						items: [
							{
								type: 'TextBlock',
								text: "<i class='fa fa-times'></i>",
								wrap: true,
								horizontalAlignment: 'right',
								color: 'attention',
							},
						],
					},
				],
			},
			{
				type: 'Container',
				separator: true,

				items: [
					{
						type: 'Image',
						wrap: true,
						url: '{{imageUrl}}',
						size: 'auto',
					},
				],
			},
			{
				type: 'Container',
				spacing: 'large',
				items: [
					{
						type: 'TextBlock',
						text: '{{title}}',
						wrap: true,
						color: 'accent',
						weight: 'bolder',
						size: 'medium',
					},
				],
			},
			{
				type: 'Container',

				spacing: 'medium',
				items: [
					{
						type: 'TextBlock',
						text: '{{patientName}}, {{articleText}}',
						wrap: true,
						color: 'default',
					},
				],
			},
			{
				type: 'Container',
				spacing: 'large',
				items: [
					{
						type: 'TextBlock',
						text: '{{linkText}}',
						wrap: true,
						color: 'accent',
					},
				],
				selectAction: {
					type: 'Action.OpenUrl',
					title: '{{linkText}}',
					url: '{{link}}',
				},
			},
		],
	};

	public static readonly AdaptiveCard_Config = {
		supportsInteractivity: true,
		fontFamily: '',
		fontSizes: {
			small: 12,
			default: 14,
			medium: 16,
			large: 19,
			extraLarge: 26,
		},
		fontWeights: {
			lighter: 200,
			default: 400,
			bolder: 700,
		},
		imageSizes: {
			small: 40,
			medium: 80,
			large: 160,
		},
		containerStyles: {
			default: {
				fontColors: {
					default: {
						normal: '#757575',
						subtle: '#757575',
					},
					accent: {
						normal: '#0155a5',
						subtle: '#0155a5',
					},
					good: {
						normal: '#222222',
						subtle: '#222222',
					},
					warning: {
						normal: '#e69500',
						subtle: '#DDe69500',
					},
					attention: {
						normal: '#75757599',
						subtle: '#75757599',
					},
				},
				backgroundColor: '#00000000',
			},
			emphasis: {
				fontColors: {
					default: {
						normal: '#333333',
						subtle: '#EE333333',
					},
					accent: {
						normal: '#2E89FC',
						subtle: '#882E89FC',
					},
					good: {
						normal: '#54a254',
						subtle: '#DD54a254',
					},
					warning: {
						normal: '#e69500',
						subtle: '#DDe69500',
					},
					attention: {
						normal: '#0155a5',
						subtle: '#0155a5',
					},
				},
				backgroundColor: '#08000000',
			},
		},
		spacing: {
			small: 1,
			default: 8,
			medium: 10,
			large: 25,
			extraLarge: 40,
			padding: 20,
		},
		separator: {
			lineThickness: 1,
			lineColor: '#3c3c3c4d',
		},
		actions: {
			maxActions: 10,
			spacing: 'Default',
			buttonSpacing: 0,
			showCard: {
				actionMode: 'Inline',
				inlineTopMargin: 6,
				style: 'Emphasis',
			},
			preExpandSingleShowCardAction: false,
			actionsOrientation: 'Vertical',
			actionAlignment: 'Left',
		},
		adaptiveCard: {
			allowCustomStyle: true,
		},
		image: {
			size: 3,
		},
		imageSet: {
			imageSize: 'Medium',
			maxImageHeight: 'maxImageHeight',
		},
		factSet: {
			title: {
				size: 'Default',
				color: 'Good',
				isSubtle: false,
				weight: 'Bolder',
				warp: true,
			},
			value: {
				size: 'Default',
				color: 'Default',
				isSubtle: false,
				weight: 'Default',
				warp: true,
			},
			spacing: 10,
		},
	};
}
